export default __webpack_public_path__ + "static/media/pay.9c7a7375.png";